import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { FLUSH, PAUSE, PERSIST, persistReducer, persistStore, PURGE, REGISTER, REHYDRATE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import apiListReducer from './features/apiListSlice';
import dashboardReducer from './features/dashboard/dashboardSlice';
import orderDetailReducer from './features/orderdetail/orderDetailSlice';
import orderListReducer from './features/orderlist/orderListSlice';
import orderSummaryReducer from './features/ordersummary/orderSummarySlice';
import loginReducer from './features/userprofile/loginSlice';
import userReducer from './features/userprofile/userSlice';

const persistConfig = {
    key: 'root',
    timeout: 500,
    storage,
  }

const reducer = combineReducers({
    dashboard: dashboardReducer,
    orderList: orderListReducer,
    orderDetail: orderDetailReducer,
    searchFieldList: orderSummaryReducer,
    apiList: apiListReducer,
    user: userReducer,
    login: loginReducer
})

const persistedReducer = persistReducer(persistConfig, reducer);

export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({
        serializableCheck: {
            ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
          },
        }),
  });

  export const persistor = persistStore(store)
